import * as defaultImport from "@splunk/visualizations/SingleValueIcon";
export * from "@splunk/visualizations/SingleValueIcon";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
